import { HttpClient } from './http-client';
import { Observable } from 'rxjs';
import User from '../interfaces/user';
import { UserData } from '../pages/external/register';
import LatvijaLvUserData from '../interfaces/latvija-lv-user-data';
import UnreadNotifications from '../interfaces/notifiation';

export class AuthService extends HttpClient {
  csrf() {
    return this.get(`/sanctum/csrf-cookie`);
  }

  login(email: string, password: string) {
    return this.post(`/api/auth/login`, { email, password });
  }

  user(): Observable<User> {
    return this.get<User>(`/api/auth/user`);
  }

  latvijaLvUserData() {
    return this.get<LatvijaLvUserData>(`/api/auth/latvija-lv-user-data`);
  }

  register(data: UserData) {
    return this.post(`/api/auth/register`, data);
  }

  forgotPassword(email: string) {
    return this.post(`/api/auth/forgot-password`, { email });
  }

  resetPassword(
    email: string,
    token: string,
    password: string,
    password_confirmation: string
  ) {
    return this.post(`/api/auth/reset-password`, {
      email,
      token,
      password,
      password_confirmation,
    });
  }

  logout() {
    return this.post(`/api/auth/logout`);
  }

  validateEmail(email: string): Observable<any> {
    return this.post(`/api/auth/validate-email`, { email });
  }

  validatePassword(password: string): Observable<void> {
    return this.post(`/api/auth/validate-password`, { password });
  }
  notificationCount(farmId: string): Observable<UnreadNotifications> {
    return this.get(`/api/farms/${farmId}/notifications/count`);
  }

  notifications(farmId: string): Observable<any> {
    return this.get(`/api/farms/${farmId}/notifications/list`);
  }

  notificationReject(
    farmId: string,
    notificationId: string,
    notificationType: string
  ): Observable<any> {
    return this.patch(`/api/farms/${farmId}/notifications/rejectNotification`, {
      notificationId: notificationId,
      notificationType: notificationType,
    });
  }

  notificationAccept(
    farmId: string,
    notificationId: string,
    notificationType: string
  ): Observable<any> {
    return this.patch(`/api/farms/${farmId}/notifications/acceptNotification`, {
      notificationId: notificationId,
      notificationType: notificationType,
    });
  }
}
